<template>
  <v-list two-line class="px-2" dense>
    <slot />
  </v-list>
</template>

<script>
export default {
  name: 'SimulationResultList',
}
</script>
